export default __webpack_public_path__ + "static/media/teamIcon.7fc2bffe.svg";